import { render } from "./PatientListView.vue?vue&type=template&id=276fc610&scoped=true"
import script from "./PatientListView.vue?vue&type=script&lang=js"
export * from "./PatientListView.vue?vue&type=script&lang=js"

import "./PatientListView.vue?vue&type=style&index=0&id=276fc610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276fc610"]])

export default __exports__